import { Component, Mixins, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import FinanceBusiness from '@/mixins/finance-business';
import { session } from '@/shared/utils/storage';

import IdenttityScoreMixins from '@/mixins/finance-identity';
import style from './index.module.scss';

const TempAmountStore = namespace('tempAmount');

/** 申请提额组件拆分 */
@Component
export default class AppQualityFinanceCard extends Mixins(
  FinanceBusiness,
  IdenttityScoreMixins,
) {
  @TempAmountStore.State tempTimeout!: number;

  @TempAmountStore.Getter isHasApplyingTempAmount!: boolean;

  @TempAmountStore.Action creditApplyTempAmount!: () => Promise<boolean>;

  /** 标记是否新版品质首页引入，待去除ab后可删除相关样式 */
  @Prop({ default: false })
  private isNew!:number

  private render() {
    return (
      <div class={this.isNew && style.newQualityWrapper}>
        <div class={style.checkLoan}>
          <div class={style.loanLeft}>
            <div class={style.images}></div>
            <div class={style.applyText}>
              <span>申请提额</span>
              <span>您还有其他渠道可申请额度</span>
            </div>
          </div>

          <div
            class={style.loanRight}
            onClick={this.onApplyCreditHandler.bind(this)}
          >
            <span class={style.buttonCheck}>{
              this.tempTimeout && this.isHasApplyingTempAmount
                ? `提额中 ${this.tempTimeout}s`
                : '去查看'
              }</span>
          </div>
        </div>
        {/** 挂载身份证清晰分不足结点，否则会显示不出来* */}
        {this.getUpdatedIdentityPhotoDialog()}
      </div>
    );
  }

  // 标记用户是否从TaglessHome切换过来的
  private getCurrentPage(): string | null {
    return session.get('currentPage') || null;
  }

  // 申请额度
  private async onApplyCreditHandler() {
    if (await this.creditApplyTempAmount()) {
      this.onApplyCredit(
        this.getCurrentPage() ? 'finance_taglessHome_checkOut' : 'finance_qualityHomePage_checkOut',
      );
    }
  }
}
